// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1Vtjq","gfeWrapper":"CalendarEvent_gfeWrapper__DfQbx"};